export class DownloadUtil {

  public static download(data: any, filename: string, type: 'text/csv' | 'application/pdf') {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);  
  }

}